<template>
    <div class="collection-preview">
        <TableOfContents
            class="collection-preview__total-toc"
            :header="header.title"
            :shouldScrollOnInit="true"
            headerIcon="stack"
        >
            <TotemScrollbar class="collection-preview__scrollbar">
                <CoursePreview
                    v-for="(item, index) in collectionAllCourses"
                    :key="index"
                    :courseItem="item"
                    :index="index + 1"
                    :isCurrent="isCurrentCourse(item.id)"
                />
            </TotemScrollbar>
        </TableOfContents>
    </div>
</template>

<script>
    import CoursePreview from './CoursePreview'
    import routeHelper from 'components/shared/mixins/routeHelper'
    import TableOfContents from 'components/coursepage/tableofcontents/TableOfContents'

    export default {
        name: 'CollectionPreview',
        mixins: [ routeHelper ],
        components: {
            CoursePreview,
            TableOfContents
        },
        props: {
            collectionAllCourses: Array,
            currentCourseId: Number,
            learningPathName: String
        },
        methods: {
            isCurrentCourse (id) {
                return id === this.currentCourseId
            }
        },
        computed: {
            header () {
                if (this.learningPathName) {
                    return {
                        title: this.learningPathName,
                        icon: 'crown'
                    }
                }
                return {
                    title: this.$t('CollectionPreview.collection_index'),
                    icon: 'stack'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .collection-preview {
        display: flex;
        flex-direction: column;
        margin: 0 0 20px;
        border: solid 2px $light_blue;
        border-radius: 20px;
        padding-bottom: 12px;
        max-height: 600px;
        overflow: hidden;

        &__button {
            align-self: center;
        }

        &__scrollbar {
            flex-grow: 1;
            background: $white;
            padding: 0px 10px;
            max-height: 535px;
        }
    }
</style>
